export { default as ArtifactPaper } from './ArtifactPaper';